export default class ThemeManager {
    static currentThemeSlug?: string;
    static setThemeSlug(themeSlug: string) {
        ThemeManager.currentThemeSlug = themeSlug;
    }
    static getCurrentThemeSlug() {
        return ThemeManager?.currentThemeSlug ?? '';
    }
}
